import { handleFiltersChanges, toggleFilterDropdown, stickyFilter } from './filter';
import { handleSidebarChanges } from './sidebar';
import { scrollToSection } from './scroll-to';

const LARGE = 1279;

const handleSectionSlider = () => {

  $( '.support-tabs__content .tab-content .section-slider' ).each( function() {
    let next = $( this ).next( '.custom-arrow-next' );
    let prev = $( this ).prev( '.custom-arrow-prev' );
    $( this ).slick({
      arrows:       true,
      nextArrow:    next,
      prevArrow:    prev,
      dots:         false,
      slidesToShow: 4,
      swipeToSlide: true,
      infinite:     false,
      responsive:   [
        {
          breakpoint: 1440,
          settings:   {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1279,
          settings:   {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 767,
          settings:   {
            slidesToShow: 1
          }
        },
      ]
    });
    $( this ).parent( '.section-slider__wrapper slick-arrow' ).removeClass( 'hide-arrow' );
    $( this ).parent( '.section-slider__wrapper' ).removeClass( 'hide-slider' );
  });
};

const showContent = () => {
  let url = window.location.href;
  let slug = url.split( '#' )[1];

  if ( slug ) {
    $( '.support-tabs .support-tabs__content[data-tab-name="' +
      slug + '"]' ).first().addClass( 'active' );
    $( '.support-tabs .sidebar-name[data-tab-name="' +
    slug + '"]' ).first().addClass( 'active' );
  } else {
    $( '.support-tabs .support-tabs__content' ).first().addClass( 'active' );
    $( '.support-tabs .sidebar-name' ).first().addClass( 'active' );
  }
};

const calculateSubpageBannerHeight = () => {
  const subpageBanner = $( '.subpage-banner.subpage-banner--support, ' +
    '.subpage-banner.subpage-banner--all-products' );
  const bannerImageWrap = $( '.subpage-banner.subpage-banner--support .banner-bg__wrapper,' +
    '.subpage-banner.subpage-banner--all-products .banner-bg__wrapper' );
  subpageBanner.css( 'height', bannerImageWrap.css( 'height' ) );
};

scrollToSection( '.support-tabs' );

$( document ).ready( function() {
  if ( window.innerWidth >= LARGE ) {
    calculateSubpageBannerHeight();
  }
  showContent();
  handleSectionSlider();
  stickyFilter( '.support-tabs .refine-results-bar' );
  toggleFilterDropdown( '.support-tabs .refine-results-bar' );
  handleFiltersChanges( '.support' );
  handleSidebarChanges( '.support-tabs__sidebar', '.support-tabs__content' );
});

// Fix foundation resize from responsive to desktop, dropdown menu bug.
jQuery( window ).on( 'changed.zf.mediaquery', ( event, newSize, oldSize ) => {
  const largeSize = [
    'large',
    'xlarge',
    'xxlarge'
  ];

  const smallSize = [
    'small',
    'medium'
  ];

  if ( newSize !== oldSize && smallSize.includes( oldSize ) && largeSize.includes( newSize ) ) {
    calculateSubpageBannerHeight();
  }
});
